import {action, computed, makeObservable, observable} from 'mobx'
import {makePersistable} from "mobx-persist-store"
import routeService from '@ui/services/RouteService'

export interface ITrack {
  points: GeolocationPosition[] // точки маршрута
	readonly isRecording: boolean	// запись маршрута
  readonly isSaveAvailable: boolean // флаг возможности сохранять трек (при достаточности точек)

	switchRecording(): boolean
  record(position: GeolocationPosition): void
}

export class Track implements ITrack {
	points: GeolocationPosition[] = []
	isRecording: boolean = false

	constructor() {
		makeObservable(this, {
			points: observable,
			isRecording: observable,
      isSaveAvailable: computed,
			switchRecording: action
		})

		makePersistable(this, {
			name: 'track',
			properties: ["points"],
			storage: window.localStorage
		})
	}

	switchRecording(): boolean {
		this.isRecording = !this.isRecording
		if (this.isRecording) {
			this.points = []
			routeService.initTrack()
		} else  {
			routeService.hideTrack()
		}
		return this.isRecording
	}

  record(position: GeolocationPosition): void {
    if (this.isRecording) {
      this.points.push(position)
      routeService.appendPointToTrack(position)
    }
  }

  get isSaveAvailable() {
    return this.isRecording && this.points.length > 3
  }
}
